import * as React from 'react';
import * as main from '../../main.module.scss';
import * as help from './style.module.scss';
import { Modal } from '../../../../Modal';
export const Help = () => {
  const [showModalVasiliy, setShowModalVasiliy] = React.useState(false);
  const [showModalUliana, setShowModalUliana] = React.useState(false);
  const [showModalOlga, setShowModalOlga] = React.useState(false);
  const [showModalVage, setShowModalVage] = React.useState(false);
  return (
    <section className={help.help}>
      <div className="container">
        <h2 className={main.title}>Вы сможете так же:</h2>
        <ul>
          <li>
            <h3>Василий Сванов</h3>
            <button
              onClick={() => {
                setShowModalVasiliy(true);
              }}
            >
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya-vzroslye-sale/kurshelp-01.png"
                alt=""
              />
            </button>
            <div>
              <p>
                <strong>Работал на заводе</strong> в Ярославской области
              </p>
              <p>
                Был в списке на <strong>сокращение</strong>
              </p>
              <p>
                Проходил наш курс по <strong>15 минут</strong> в день после 12-часовой рабочей смены
              </p>
              <p>
                <strong>Вместо сокращения</strong> стал руководителем <strong>и увеличил зарплату в три раза!</strong>
              </p>
              <p>Посмотрите его историю сами!</p>
            </div>
          </li>
          <li>
            <h3>Ульяна</h3>
            <button
              onClick={() => {
                setShowModalUliana(true);
              }}
            >
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya-vzroslye-sale/kurshelp-02.png"
                alt=""
              />
            </button>
            <div>
              <p>
                <strong>Уставала</strong> на работе каждый день
              </p>
              <p>
                <strong>Не было времени</strong> на себя
              </p>
              <p>
                <strong>Боялась</strong>, что не хватит сил и не закончит обучение
              </p>
              <p>
                За год <strong>освоила профессию</strong> маркетолога
              </p>
              <p>
                Подняла уровень владения <strong>английским</strong>
              </p>
              <p>
                Легко прошла много других курсов и <strong>купила собственную квартиру</strong>
              </p>
            </div>
          </li>
          <li>
            <h3>Ольга, 46 лет</h3>
            <button
              onClick={() => {
                setShowModalOlga(true);
              }}
            >
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya-vzroslye-sale/kurshelp-03.png"
                alt=""
              />
            </button>
            <div>
              <p>
                <strong>Мечтала</strong> из технаря стать психологом
              </p>
              <p>
                <strong>Трудности</strong> с запоминанием материала
              </p>
              <p>
                <strong>Путалась</strong> в терминах и определениях
              </p>
              <p>
                Легко <strong>освоила новую профессию</strong> психолога
              </p>
              <p>
                Стала <strong>примером</strong> для сына девятиклассника
              </p>
              <p>
                Перешла <strong>на фриланс</strong> с удобным графиком
              </p>
            </div>
          </li>
          <li>
            <h3>Ваге Багдасарян</h3>
            <button
              onClick={() => {
                setShowModalVage(true);
              }}
            >
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya-vzroslye-sale/kurshelp-04.png"
                alt=""
              />
            </button>
            <div>
              <p>
                <strong>Всю жизнь мечтал летать</strong>
              </p>
              <p>Купил дорогое обучение на пилота и понял, что не вытягивает</p>
              <p>
                <strong>За месяц</strong> подготовился и успешно сдал восемь экзаменов на летную лицензию (PPL)
              </p>
              <p>
                Все экзамены были <strong>на английском языке</strong>, его уровень он тоже поднял
              </p>
              <p>
                <strong>Повысил уверенность</strong> в себе
              </p>
              <p>
                <strong>Исполнил мечту</strong> и стал пилотом!
              </p>
            </div>
          </li>
        </ul>
      </div>

      <Modal
        open={showModalVasiliy}
        onClose={() => {
          setShowModalVasiliy(false);
        }}
        maxWidth={'md'}
      >
        <div style={{ width: '100%', padding: '30px' }}>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              title={'Отзыв Василия Сванова'}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_Cy4nbgtsTUQ1LPc"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={showModalUliana}
        onClose={() => {
          setShowModalUliana(false);
        }}
        maxWidth={'md'}
      >
        <div style={{ width: '100%', padding: '30px' }}>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              title={'Отзыв Ульяны'}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_qqeSAlQ02qqjCbBH"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={showModalOlga}
        onClose={() => {
          setShowModalOlga(false);
        }}
        maxWidth={'md'}
      >
        <div style={{ width: '100%', padding: '30px' }}>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              title={'Отзыв Ольги'}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_VoyhNS1JLr0J8G"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={showModalVage}
        onClose={() => {
          setShowModalVage(false);
        }}
        maxWidth={'md'}
      >
        <div style={{ width: '100%', padding: '30px' }}>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              title={'Отзыв Ваге Багдасаряна'}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_OTwRBgLuuZFh9Xtj"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>
    </section>
  );
};
